import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useColors } from "../../../Context/ColorsContext";
import { MediaQuerys } from "../../../styles/GlobalStyle";

const { mobile, tablet, desktop, desktoplarge } = MediaQuerys;

export const ButtonOptions = styled(Button)(({btnType}) => {
  const { colors } = useColors();
  return {
    height: "30px",
    width: "100%",
    padding: "0 10px",
    textTransform: "none",
    backgroundColor: colors.sidebarSelectColor,
    color: colors.white,
    boxShadow: "none",
    borderRadius: 8,
    fontSize: "14px !important",
    "&:hover": {
      backgroundColor: colors.sidebarSelectColor,
      opacity: 0.9,
      color: colors.white,
      boxShadow: "none",
    },
    [tablet]: {
      fontSize: "12px !important",
    },
  };
});